import React from "react";
import { useNavigate } from "react-router-dom";
import GlobalBreadcrumbs from "../../components/global/GlobalBreadcrumbs";
import WrapperSection from "../../components/global/WrapperSection";
import FormAddEditBlog from "../../components/blog/FormAddEditBlog";

const CreateBlogPost = () => {
    const navigate = useNavigate();

    const handleSuccess = () => {
        navigate("/blog");
    };

    return (
        <WrapperSection>
            <GlobalBreadcrumbs />
            <FormAddEditBlog isEdit={false} currentData={null} onSubmitSuccess={handleSuccess} />
        </WrapperSection>
    );
};

export default CreateBlogPost;
